// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileAddTwoToneSvg from "@fishx/icons-svg/es/asn/FileAddTwoTone";
import FishxIcon from '../components/FishxIcon';

var FileAddTwoTone = function FileAddTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileAddTwoToneSvg
  }));
};

FileAddTwoTone.displayName = 'FileAddTwoTone';
export default React.forwardRef(FileAddTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileAddTwoTone.js
// module id = 2683
// module chunks = 0